import React, { createContext, useEffect, useMemo, useState } from 'react'
import PropTypes from 'prop-types'
import TabsGroupContext from './TabsGroupContext'

/**
 * @type {React.Context<{ idPrefix: string; value: string } | null>}
 */

function useUniquePrefix() {
	const [id, setId] = useState(null)
	useEffect(() => {
		setId(`Vb-p-${Math.round(Math.random() * 1e5)}`)
	}, [])
	return id
}

export default function TabsContext(props) {
	const { children, value: valueProp } = props

	// set the Tabs to its default selected tab. If not setted, nor tab indicator or pannel is shown
	const [value, setValue] = useState(valueProp)
	const idPrefix = useUniquePrefix()

	const getTabId = () => {
		if (idPrefix === null) {
			return null
		}
		return `${idPrefix}-T-${value}`
	}

	const getPanelId = () => {
		if (idPrefix === null) {
			return null
		}
		return `${idPrefix}-P-${value}`
	}

	const handleChange = (_, newValue) => {
		setValue(newValue)
	}

	const context = useMemo(() => {
		return { idPrefix, value, handleChange, getTabId, getPanelId }
	}, [idPrefix, value])

	return <TabsGroupContext.Provider value={context}>{children}</TabsGroupContext.Provider>
}

TabsContext.propTypes = {
	/**
	 * The content of the component.
	 */
	children: PropTypes.node,
	/**
	 * The value of the currently selected `Tab`.
	 */
	value: PropTypes.string.isRequired
}
